// Utilidades de fecha para la plataforma. La zona horaria oficial es México
// (America/Mexico_City). Las fechas programadas se guardan como "YYYY-MM-DD"
// y NO deben convertirse a UTC al mostrarse (eso provocaba que la fecha
// retrocediera un día en husos horarios detrás de UTC).

const MX_TZ = "America/Mexico_City";

// Formatea una fecha programada ("YYYY-MM-DD" o ISO) para mostrarla al usuario
// en formato largo de México, sin desfase de zona horaria.
export function formatDateMX(value) {
  if (!value) return null;
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const [, y, mo, d] = m;
    // Construimos la fecha en horario local para evitar el corrimiento UTC.
    const local = new Date(Number(y), Number(mo) - 1, Number(d));
    return new Intl.DateTimeFormat("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(local);
  }
  // Valor con hora: lo interpretamos y mostramos en zona horaria de México.
  const dt = new Date(s);
  if (Number.isNaN(dt.getTime())) return s;
  return new Intl.DateTimeFormat("es-MX", {
    dateStyle: "long",
    timeZone: MX_TZ,
  }).format(dt);
}

// Fecha de "hoy" en México como string "YYYY-MM-DD" (útil para inputs date y
// comparaciones lexicográficas seguras).
export function todayMX() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: MX_TZ }).format(new Date());
}
